import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col } from "reactstrap";
import DataTable from "../../components/Table/Table";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/pro-light-svg-icons/faTrash';
import PageHeader from "../../components/Header/PageHeader";
import { ConfirmAction, ToggleColumn } from '../../components/Table/NewTable';
import { deleteEgressProvider, getEgressProviders, updateEgressProvider } from '../../actions/actionEgressProvider';
import { faArrowProgress } from '@fortawesome/pro-light-svg-icons/faArrowProgress';
import { notifyFailure, notifySuccess } from '../../components/Form/Form';
import LoadingSpinner from '../../components/LoadingSpinner';

export default function EgressProvider(props) {

    const { t } = useTranslation('common');
    const dispatch = useDispatch()
    const [modal, setModal] = useState(false)
    const [provider, setProvider] = useState(null)
    const egress_providers = useSelector(state => state.egress_provider.egress_providers) || null
    const egressProviderLoading = useSelector(state => state.egress_provider.egressProviderLoading) || null

    useEffect(() => {
        dispatch(getEgressProviders())
    }, []);

    const deleteEgressProviderAction = async (setProvider = false) => {
        const egress_provider_id = setProvider || provider
        let data = { egress_provider_id }
        try {
            const { response: { error_message: errorMessage } } = await dispatch(deleteEgressProvider(data));
            notifySuccess({ errorMessage, type: 'delete' })
            if (!setProvider) {
                dispatch(getEgressProviders())
            }
            setModal(false)
        } catch (error) {
            notifyFailure({ error, type: 'delete' })
            setModal(false)
        }
    }

    const tableColumns = [
        {
            type: "text",
            name: t('egress_provider.name'),
            accessor: "name",
        },
        {
            type: "text",
            name: t('egress_provider.type'),
            accessor: "egress_provider_type",
        },
        {
            type: "flag",
            name: t('egress_provider.enabled'),
            accessor: "enabled",
            overwrite: true,
            cell: (data) => <ToggleColumn key={'enabled-' + data.original.egress_provider_id} id="egress_provider_id" column="Enabled" data={data} onChange={(e) => onAction('toggle', { id: 'enabled', data: data.original, value: e.target.checked } )}/>
        },
        {
            type: "flag",
            name: t('egress_provider.is_managed'),
            accessor: "is_managed",
        },
        {
            type: "text",
            name: t('egress_provider.egress-provider-id-full'),
            accessor: "egress_provider_id",
            showByDefault: false,
        }
    ];

    const actions = [
        { id: "edit", icon: "fa-pencil", description: t('buttons.Edit') },
        { id: "delete", icon: "fa-trash", description: t('buttons.Delete') },
    ];

    const onAction = async (action, item) => {
        switch (action) {

            case "edit":
                props.history.push(`/update_egress_provider/${item.egress_provider_id}`);
                break;

            case "delete":
                setProvider(item.egress_provider_id)
                setModal(true)
                break;

            case "deleteMulti":
                const promises = []
                item.forEach(id => {
                    const promise = deleteEgressProviderAction(id)
                    promises.push(promise)
                })
                await Promise.all(promises)
                dispatch(getEgressProviders())
                break;

            case "toggle":
                const validToggles = ['enabled'];
                if(validToggles.indexOf(item.id) !== -1) {
                    let newData = {
                        ...item.data
                    }
                    newData[item.id] = !!item.value; // Toggle the value passed

                    try {
                        const { response: { error_message: errorMessage } } = await dispatch(updateEgressProvider(newData));
                        notifySuccess({
                            errorMessage,
                            type: 'update'
                        })
                        dispatch(getEgressProviders())
                    } catch (error) {
                        notifyFailure({ error, type: 'update' })
                    }

                }
            break;

        }
    }

    if (egressProviderLoading) {
        return (<div> <LoadingSpinner /></div>);
    }

    return (
        <div className="profile-page">
            <PageHeader location={props.location} routes={typeof newRoutes !== 'undefined' ? newRoutes : null} help="kb-26-0" title={t('egress_provider.egress-providers')} icon={<FontAwesomeIcon icon={faArrowProgress} />} />
            <Row>
                <Col sm={{ size: 10, order: 3, offset: 1 }}>
                    <DataTable
                        id="egress_provider"
                        data={egress_providers}
                        columns={tableColumns}
                        actions={actions}
                        onAction={onAction}
                        mainId="egress_provider_id"
                        add={{
                            name: t('buttons.Add'),
                            action: '/create_egress_provider'
                        }}
                    />
                </Col>
            </Row>

            <ConfirmAction
                confirmationDetails={{
                    action: null,
                    details: {
                        title: t('egress_provider.notify-delete-title'),
                        text: t('egress_provider.are-you-sure-you-want-to-delet'),
                        iconBg: 'tw-bg-pink-700 tw-text-white',
                        icon: <FontAwesomeIcon icon={faTrash} />,
                        confirmBg: 'tw-bg-pink-700',
                        confirmText: t('buttons.Delete'),

                    }
                }}
                open={modal}
                externalClose={true}
                setOpen={setModal}
                onAction={deleteEgressProviderAction}
            />
        </div>
    );
}
